export default __webpack_public_path__ + "static/quienes-somos-729f49b4917832e665fe0f891e831638.png";